import { Header } from '@shared';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import { ReactNode } from 'react';
import Portal from './Portal';

const FullScreenModal = ({
  children,
  isOpen,
  onClose,
  fullWidth = false,
  topPadding = true,
  withMaxWidth = true,
  withHeader = true
}: {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  fullWidth?: boolean;
  topPadding?: boolean;
  withMaxWidth?: boolean;
  withHeader?: boolean;
}): ReactNode => {
  if (!isOpen) return null;

  return (
    <Portal>
      {/* eslint-disable react/no-unknown-property*/}
      <style jsx global>
        {`
          body {
            overflow: hidden;
          }
        `}
      </style>
      <div
        className={classNames('fixed top-0 left-0 z-50 w-screen h-dvh', setupForDark('bg-page'))}
        onClick={() => {
          onClose();
        }}
      >
        <div
          className={classNames(
            'flex flex-col h-full',
            fullWidth
              ? 'w-full'
              : classNames(
                  withMaxWidth
                    ? 'dk:max-w-screen-md dk:mx-auto dk:border-r-[1px] dk:border-l-[1px]'
                    : '',
                  setupForDark('border-primary')
                )
          )}
        >
          {withHeader && <Header withX onXClicked={onClose} />}
          <div
            onClick={(e) => e.stopPropagation()}
            className={classNames('flex-1 overflow-hidden', {
              'pt-[44px]': topPadding
            })}
          >
            {children}
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default FullScreenModal;
